import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

import './WeekView.css'

export default class HeaderRow extends React.Component {

  static propTypes = {
    days: PropTypes.array.isRequired,
    onDayHeaderClicked: PropTypes.func.isRequired
  }

  handleDayHeaderClicked = day => {
    const newDateStr = moment(day.key).format('YYYY-MM-DD')
    this.props.onDayHeaderClicked('day', newDateStr)
  }
  
  renderDays() {
    const result = []
    for (const key in this.props.days) {
      const day = this.props.days[key]
      result.push(
        <div
          style={styles.headerRowDay(day.isToday)}
          className='header-row'
          key={day.key}
          onTouchTap={() => this.handleDayHeaderClicked(day)}>
          { day.displayName }
        </div>
      )
    }
    result.push(<div key='matcher' style={styles.matcher} />)
    return result
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.headerRowInfo}>
          &nbsp;
        </div>
        { this.renderDays() }
      </div>
    )
  }
}

const styles = {
  container: {
    display: 'flex',
    borderBottom: '#e0e0e0 1px solid'
  },
  headerRowInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'center',
    flexShrink: 0,
    color: '#455559',
    flex: 1,
    borderRight: '#e0e0e0 1px solid'
  },
  headerRowDay: isToday => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'center',
    flexShrink: 0,
    color: '#455559',
    flex: 1,
    borderRight: '#e0e0e0 1px solid',
    backgroundColor: isToday ? 'rgba(0, 0, 0, 0.04)' : undefined
  }),
  matcher: {
    overflow: 'scroll',
    visibility: 'hidden',
    flex: 'none'
  }
}



// WEBPACK FOOTER //
// ./src/schedule/week/HeaderRow.js